import React from 'react';

type Props = React.SVGProps<SVGSVGElement> & { title?: string };

export function IconCart(props: Props) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden={props.title ? undefined : true} {...props}>
      {props.title ? <title>{props.title}</title> : null}
      <path
        d="M6 6h15l-1.6 8.2a2 2 0 0 1-2 1.6H9a2 2 0 0 1-2-1.6L5.4 3.8A1 1 0 0 0 4.4 3H2"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9.5 21a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" fill="currentColor" />
      <path d="M17.5 21a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" fill="currentColor" />
    </svg>
  );
}

export function IconArrowRight(props: Props) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden={props.title ? undefined : true} {...props}>
      {props.title ? <title>{props.title}</title> : null}
      <path
        d="M5 12h12"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 6l6 6-6 6"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconCheck(props: Props) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden={props.title ? undefined : true} {...props}>
      {props.title ? <title>{props.title}</title> : null}
      <path
        d="M20 7 10 17l-5-5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconPhone(props: Props) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden={props.title ? undefined : true} {...props}>
      {props.title ? <title>{props.title}</title> : null}
      <path
        d="M6.5 3.5h2.2a2 2 0 0 1 2 1.6l.6 2.6a2 2 0 0 1-.6 1.9l-1.5 1.3a14.8 14.8 0 0 0 6.9 6.9l1.3-1.5a2 2 0 0 1 1.9-.6l2.6.6a2 2 0 0 1 1.6 2v2.2a2 2 0 0 1-2 2C10.3 24.5-.5 13.7-.5 2.5a2 2 0 0 1 2-2h3z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconWhatsApp(props: Props) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden={props.title ? undefined : true} {...props}>
      {props.title ? <title>{props.title}</title> : null}
      <path
        d="M12 22a10 10 0 1 0-8.6-4.9L2 22l5-1.3A10 10 0 0 0 12 22Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path
        d="M9.2 8.9c.1-.5.5-.9 1-.9h.7c.3 0 .6.2.7.5l.7 1.7c.1.3 0 .6-.2.8l-.6.6c.7 1.3 1.8 2.4 3.1 3.1l.6-.6c.2-.2.6-.3.8-.2l1.7.7c.3.1.5.4.5.7v.7c0 .5-.3.9-.9 1-1 .2-2.6.2-4.8-1.1-2.3-1.3-4-3.7-4.7-5.1-.7-1.4-.6-2.6-.4-3.5Z"
        fill="currentColor"
        opacity="0.9"
      />
    </svg>
  );
}

export function IconStar(props: Props) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden={props.title ? undefined : true} {...props}>
      {props.title ? <title>{props.title}</title> : null}
      <path
        d="M12 2l3 7 7 .6-5.3 4.6 1.7 7-6.4-3.9-6.4 3.9 1.7-7L2 9.6 9 9l3-7Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IconDoc(props: Props) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden={props.title ? undefined : true} {...props}>
      {props.title ? <title>{props.title}</title> : null}
      <path
        d="M7 3h7l3 3v15a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path d="M14 3v3h3" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <path d="M8 12h8M8 16h8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

export function IconMenu(props: Props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden={props.title ? undefined : true} {...props}>
      {props.title ? <title>{props.title}</title> : null}
      <path d="M3 12h18M3 6h18M3 18h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function IconClose(props: Props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden={props.title ? undefined : true} {...props}>
      {props.title ? <title>{props.title}</title> : null}
      <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function IconSearch(props: Props) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden={props.title ? undefined : true} {...props}>
      {props.title ? <title>{props.title}</title> : null}
      <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="m21 21-4.35-4.35" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function IconInstagram(props: Props) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden={props.title ? undefined : true} {...props}>
      {props.title ? <title>{props.title}</title> : null}
      <rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="17.2" cy="6.8" r="1.2" fill="currentColor" />
    </svg>
  );
}

export function IconTrash(props: Props) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden={props.title ? undefined : true} {...props}>
      {props.title ? <title>{props.title}</title> : null}
      <path
        d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6h14Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10 11v6M14 11v6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

export function IconHardHat(props: Props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden={props.title ? undefined : true} {...props}>
      {props.title ? <title>{props.title}</title> : null}
      <path d="M4 14a8 8 0 0 1 16 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M12 6v8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M3 16h18v2.2a1.8 1.8 0 0 1-1.8 1.8H4.8A1.8 1.8 0 0 1 3 18.2V16Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    </svg>
  );
}

export function IconShield(props: Props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden={props.title ? undefined : true} {...props}>
      {props.title ? <title>{props.title}</title> : null}
      <path d="M12 3 5 6v6.2c0 4.2 2.8 7.4 7 8.8 4.2-1.4 7-4.6 7-8.8V6l-7-3Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      <path d="m9 12 2 2 4-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function IconLayers(props: Props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden={props.title ? undefined : true} {...props}>
      {props.title ? <title>{props.title}</title> : null}
      <path d="m12 4 8 4-8 4-8-4 8-4Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      <path d="m4 12 8 4 8-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="m4 16 8 4 8-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function IconClipboard(props: Props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden={props.title ? undefined : true} {...props}>
      {props.title ? <title>{props.title}</title> : null}
      <path d="M9 4h6a2 2 0 0 1 2 2v1h1.2A1.8 1.8 0 0 1 20 8.8v11.4A1.8 1.8 0 0 1 18.2 22H5.8A1.8 1.8 0 0 1 4 20.2V8.8A1.8 1.8 0 0 1 5.8 7H7V6a2 2 0 0 1 2-2Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      <path d="M9 7h6V5.5A1.5 1.5 0 0 0 13.5 4h-3A1.5 1.5 0 0 0 9 5.5V7Z" stroke="currentColor" strokeWidth="1.8" />
      <path d="M8 12h8M8 16h5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

export function IconTruck(props: Props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden={props.title ? undefined : true} {...props}>
      {props.title ? <title>{props.title}</title> : null}
      <path d="M3 7h11v9H3V7Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      <path d="M14 10h4.2L21 13.2V16h-7v-6Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      <circle cx="7" cy="17.5" r="1.7" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="17" cy="17.5" r="1.7" stroke="currentColor" strokeWidth="1.8" />
    </svg>
  );
}

export function IconHeadset(props: Props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden={props.title ? undefined : true} {...props}>
      {props.title ? <title>{props.title}</title> : null}
      <path d="M4.5 13.5V12a7.5 7.5 0 0 1 15 0v1.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M4.5 13.5A2.2 2.2 0 0 0 6.7 15.7H7v-4H6.7a2.2 2.2 0 0 0-2.2 2.2ZM19.5 13.5A2.2 2.2 0 0 1 17.3 15.7H17v-4h.3a2.2 2.2 0 0 1 2.2 2.2Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      <path d="M19.5 16.5v1.2A2.3 2.3 0 0 1 17.2 20H13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}
